import React from 'react'
import { PageBodyNavigation } from '../PageLayout/PageLayout'
import { PageFooterTemplate } from '../PageTemplate/PageFooterTemplate'
import { PageHeaderTemplate } from '../PageTemplate/PageHeaderTemplate'
import { PageTemplate } from '../PageTemplate/PageTemplate'
import type {
  DetailPageFooterTemplateProps,
  DetailPageHeaderTemplateProps,
  DetailPageTemplateProps,
} from './DetailPageTemplate.types'

export const DetailPageHeaderTemplate = React.forwardRef<
  HTMLDivElement,
  DetailPageHeaderTemplateProps
>((props, ref) => {
  return (
    <PageHeaderTemplate
      ref={ref}
      {...props}
      data-core-react="detail-page-header-template"
    />
  )
})

export const DetailPageFooterTemplate = React.forwardRef<
  HTMLDivElement,
  DetailPageFooterTemplateProps
>((props, ref) => {
  return (
    <PageFooterTemplate
      ref={ref}
      {...props}
      data-core-react="detail-page-footer-template"
    />
  )
})

export const DetailPageTemplate = React.forwardRef<
  HTMLDivElement,
  DetailPageTemplateProps
>(
  (
    {
      header,
      headerProps,
      children,
      footer,
      footerProps,
      hasNavigation,
      ...props
    },
    ref
  ) => {
    return (
      <PageTemplate
        data-core-react="detail-page-template"
        header={header ?? <DetailPageHeaderTemplate {...headerProps!} />}
        footer={
          footer ?? (
            <DetailPageFooterTemplate
              {...footerProps}
              actions={footerProps?.actions!}
            />
          )
        }
        innerPane={hasNavigation && <PageBodyNavigation minSections={3} />}
        {...props}
        ref={ref}
      >
        {children}
      </PageTemplate>
    )
  }
)
